module.exports = __webpack_public_path__ + "static/img/failure_logo.b79f3b78.png";